import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { MapLink, MapLinkText } from '../styled';
import { getMapUrl } from '../../../../utils/helpers/search';
import Icon from '../../../Icon';
import MapIcon from '../../../../public/static/images/new_search/icons/map-icon.svg';

export const MapButton = () => {
  const {
    t,
    i18n: { language }
  } = useTranslation();
  const router = useRouter();
  const [mapUrl, setMapUrl] = useState<string>(
    getMapUrl(language, router.asPath)
  );

  useEffect(() => {
    setMapUrl(getMapUrl(language, router.asPath));
  }, [router.asPath, language]);

  return (
    <MapLink
      href={mapUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-cy="new-search-map-link"
      data-stat="new-search-map-link"
    >
      <Icon IconComponent={MapIcon} width={20} height={20} indent={false} />
      <MapLinkText tag="body_1">{t('new_search.map')}</MapLinkText>
    </MapLink>
  );
};
